import { defineMessages } from 'react-intl';
import PropTypes from 'prop-types';

const overflowOptions = [
  { name: 'Pagination', value: 'pagination', labelId: 'PAGINATION' },
  { name: 'Scroll', value: 'scroll', labelId: 'SCROLL' },
];

export const controlsList = [{
  name: 'overflow',
  labelId: 'OVERFLOW',
  type: 'select',
  default: 'pagination',
  options: overflowOptions,
}, {
  name: 'headerFontSize',
  labelId: 'HEADER_FONT_SIZE',
  type: 'slider',
  default: 14,
  options: {
    min: 8,
    max: 40,
    step: 1,
  },
}, {
  name: 'bodyFontSize',
  labelId: 'BODY_FONT_SIZE',
  type: 'slider',
  default: 14,
  options: {
    min: 8,
    max: 40,
    step: 1,
  },
}, {
  name: 'cellPadding',
  labelId: 'CELL_PADDING',
  type: 'slider',
  default: 4,
  options: {
    min: 1,
    max: 20,
    step: 1,
  },
}];

const messages = defineMessages({
  OVERFLOW: {
    id: 'OVERFLOW',
    defaultMessage: 'Overflow',
  },
  PAGINATION: {
    id: 'PAGINATION',
    defaultMessage: 'Pagination',
  },
  SCROLL: {
    id: 'SCROLL',
    defaultMessage: 'Scroll',
  },
  NONE: {
    id: 'NONE',
    defaultMessage: 'None',
  },
  TABLE: {
    id: 'TABLE',
    defaultMessage: 'Table',
  },
  FONT_SIZE: {
    id: 'FONT_SIZE',
    defaultMessage: 'Font Size',
  },
  HEADER_FONT_SIZE: {
    id: 'HEADER_FONT_SIZE',
    defaultMessage: 'Header Font Size',
  },
  BODY_FONT_SIZE: {
    id: 'BODY_FONT_SIZE',
    defaultMessage: 'Body Font Size',
  },
  CELL_PADDING: {
    id: 'CELL_PADDING',
    defaultMessage: 'Cell Padding',
  },
});

function TableStyleControls({ renderControlGroup }) {
  const controlsGroups = [{
    labelId: 'TABLE',
    controls: controlsList,
  }];

  return controlsGroups.map(
    (controlsGroup, cgIndex) => renderControlGroup(controlsGroup, messages, cgIndex),
  );
}

TableStyleControls.propTypes = {
  renderControlGroup: PropTypes.func.isRequired,
};

export default TableStyleControls;
